module.exports = __webpack_public_path__ + "static/media/upcomingBadge.9c8d6e06.svg";